module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box",
    class: _vm.addBackground
  }, [_c('div', {
    staticClass: "c-header",
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [(_vm.addBackground === '') ? _c('img', {
    attrs: {
      "src": require("./images/header-logo-white-xd.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])]), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "introduce-slide"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "Course"
    }
  }, [_vm._v("公司简介")]), _c('div', {
    staticClass: "slide-box"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.timeLineList), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v("\n              " + _vm._s(item.date) + "\n            ")]), _c('div', {
      staticClass: "text"
    }, [_c('h2'), _c('p', [_vm._v(_vm._s(item.content))])])])])
  }), 1), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex('prev')
      }
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex('next')
      }
    },
    slot: "button-next"
  })], 1), _c('div', {
    staticClass: "time-line"
  }, [_c('div', {
    staticClass: "time-line-box",
    style: ({
      width: _vm.currentWidth + 'px',
      left: _vm.currentLeft + 'px'
    })
  }, _vm._l((_vm.timeLineList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "time-line-item",
      on: {
        "click": function($event) {
          return _vm.timeLineHandler(index)
        }
      }
    }, [_c('span', {
      class: index === _vm.currentIndex ? 'selected' : 'not-selected'
    }), _c('p', [_vm._v(_vm._s(item.date))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduce"
  }, [_c('dl', [_c('dt', {
    attrs: {
      "id": "Introduce"
    }
  }, [_vm._v("\n        公司简介\n      ")]), _c('dd', [_vm._v("\n        八戒小贷全称为重庆市猪八戒宜创小额贷款有限公司，成立于2016年5月，注册资本金30000万元人民币。是由重庆市金融办批准成立的正规非银行金融机构，是全国第19家有牌照的互联网小贷公司。公司成立于2016年，致力于为猪八戒网用户乃至更多的小微企业及企业主提供数字普惠金融服务，助力数字普惠金融在中国的发展，同时结合创新互联网技术，将传统金融与大数据、互联网技术相结合，探索全新的科技金融发展模式，搭建开放、共享的体系服务平台。科技金融发展模式，搭建开放、共享的体系服务平台。\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporate-culture"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "Cultrue"
    }
  }, [_vm._v("企业文化")]), _c('ul', [_c('li', {
    staticClass: "illustration-1"
  }), _c('li', [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-mission.png"),
      "alt": ""
    }
  })]), _c('dd', {
    staticClass: "has-line"
  }, [_vm._v("使命")]), _c('dd', {
    staticClass: "word"
  }, [_vm._v("为用户提供普惠、便捷、优质的金融产品")])])]), _c('li', [_c('dl', [_c('dt', {
    staticClass: "add-top"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-vision.png"),
      "alt": ""
    }
  })]), _c('dd', {
    staticClass: "has-line"
  }, [_vm._v("愿景")]), _c('dd', {
    staticClass: "word"
  }, [_vm._v("建设中国领先的数据")]), _c('dd', {
    staticClass: "word"
  }, [_vm._v("普惠金融服务平台")])])]), _c('li', {
    staticClass: "illustration-2"
  }), _c('li', {
    staticClass: "illustration-3"
  }), _c('li', [_c('dl', [_c('dt', {
    staticClass: "add-top"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-value.png"),
      "alt": ""
    }
  })]), _c('dd', {
    staticClass: "has-line"
  }, [_vm._v("价值观")]), _c('dd', {
    staticClass: "word"
  }, [_vm._v("关注小微、普惠大众")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cfbfb324", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfbfb324","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/aboutUs.vue
// module id = 1208
// module chunks = 2